import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ErrorStreamChange } from '../models/$error.model';
import { EventService } from './event.service';
import { takeUntil, take } from 'rxjs/operators';
import { UserService } from './user.service';
import { environment } from '../../../src/environments/environment';
import { Store } from '@ngrx/store';
// import { ResetNotices, LoadNotices, Notice, ChangeNoticesLoadingStatus, DeleteNotice } from '../store/notices.era';
import { HttpClient } from '@angular/common/http';
import { OnReset, Transitions } from './transition.service.helpers';
import { Notice, noticesActions } from '../store/notices.era';
import { addDoc, updateDoc, collection, deleteDoc, doc, Firestore, collectionChanges } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class NoticesService implements OnReset {

  readonly _file: string = 'notices.service.ts';
  readonly api = `${environment.functionsURL}api/app`;
  // public $events: Subject<EventStreamChange> = new Subject();
  public $errors: Subject<ErrorStreamChange> = new Subject();
  public $unsubscribe: Subject<boolean> = new Subject();
  private sub: Subscription

  onReset(resetType, value = null) {
    switch (resetType) {
      case Transitions.OnEnterEvent:
        return this.subscribeToNotices(value.eventId)
      case Transitions.OnExitEvent:
        return this.$unsubscribe.next(true)
      default:
        break;
    }
  }

  subscribeToNotices(eventId) {
    if (!eventId) {
      console.log("Could not subscribe to notices, no eventId provided")
      return
    }

    collectionChanges(collection(this.db, `events/${eventId}/notices`)).pipe(takeUntil(this.$unsubscribe))
    .subscribe(changes=> { 

      // delete removed notices from store
      changes.filter(({ type }) => type === 'removed').map(c => this.store.dispatch(noticesActions.deleteNotice(c.doc.id)))

      // add new or modified ones (no way to modify atm besides read state, but still)
      const notices: Notice[] = changes.filter(({ type }) => type !== 'removed').map(change => {
        const id = change.doc.id
        const notice = change.doc.data() as Notice
        notice.id = id
        return notice
      })
      
      if (notices.length) this.store.dispatch(noticesActions.loadNotices(notices))
      else this.store.dispatch(noticesActions.changeNoticesLoadingStatus(false)) // remove loading bar by setting isLoading to false
    })
  }

  constructor(
    private eventService: EventService, 
    private http: HttpClient,
    private userService: UserService, 
    public store: Store,
    private db: Firestore,
  ) { }

  markAllRead() {
    this.store.dispatch(noticesActions.changeNoticesLoadingStatus(true))
    return this.http.post(`${this.api}/batch-update-notices-seen`, { eventId: this.eventService.eventId }).pipe(take(1)).subscribe(response => {
      this.store.dispatch(noticesActions.changeNoticesLoadingStatus(false))
    }, error => {
      this.store.dispatch(noticesActions.changeNoticesLoadingStatus(false))
      return console.error(error)
    })
  }

  private dispatchNotice(notice, action: string): Promise<any> {
    switch (action) {
      case "add":
        return addDoc(collection( this.db, `events/${this.eventService.eventId}/notices`), notice)
      case "update":
        return updateDoc(doc(this.db, `events/${this.eventService.eventId}/notices/${notice.id}`), notice)
      case "delete":
        this.store.dispatch(noticesActions.deleteNotice(notice.id))
        return deleteDoc(doc(this.db, `events/${this.eventService.eventId}/notices/${notice.id}`))
      default:
        return new Promise(resolve => resolve({ message: 'Action is empty' }))
    }
  }

  writeNotice(notice, action: string) {
    this.store.dispatch(noticesActions.changeNoticesLoadingStatus(true))
    this.dispatchNotice(notice, action).then(_ => this.store.dispatch(noticesActions.changeNoticesLoadingStatus(false)))
  }
}
